export default function LogoMark({ size = 36, className = "" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Bordverket logo"
      style={{ height: size, width: "auto" }}
      className={`mix-blend-screen ${className}`}
    />
  );
}
